import { render, staticRenderFns } from "./DeleteItem.vue?vue&type=template&id=372383f9&scoped=true"
import script from "./DeleteItem.vue?vue&type=script&lang=js"
export * from "./DeleteItem.vue?vue&type=script&lang=js"
import style0 from "./DeleteItem.vue?vue&type=style&index=0&id=372383f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372383f9",
  null
  
)

export default component.exports